const STOREFRONT_API_VERSION = '2022-07';
const { apiKey: STOREFRONT_API_KEY } = window.config.storefront;

const STOREFRONT_API_URL = `/api/${STOREFRONT_API_VERSION}/graphql.json`;

/** @type {RequestInit} */
const requestDefaults = {
  async: true,
  crossDomain: true,
  method: 'POST',
  headers: {
    'X-Shopify-Storefront-Access-Token': STOREFRONT_API_KEY,
    'Content-Type': 'application/graphql',
  },
};

const fetchFromStorefront = body => {
  return fetch(STOREFRONT_API_URL, {
    ...requestDefaults,
    body,
  }).then(response => response.json());
};

export default fetchFromStorefront;
